import type { DateIso, Phase } from '../../types/domain';
import { fmtDate } from '../format';

// Message d'erreur si une affectation commence avant sa phase (aucune phase n'est prévue sur ces
// dates), sinon null. La fin au-delà de la phase reste gérée par la proposition de prolongation.
export function assignmentBeforePhaseError(
  phase: Pick<Phase, 'nom' | 'dateDebut'> | null | undefined,
  debut: DateIso | null | undefined,
): string | null {
  if (!phase?.dateDebut || !debut || debut >= phase.dateDebut) return null;
  return (
    `Impossible : aucune phase n’est prévue avant le ${fmtDate(phase.dateDebut)}, ` +
    `date de début de la phase « ${phase.nom} ».\n\n` +
    'Décale le début de l’affectation, ou avance la date de début de la phase.'
  );
}
